import { render, staticRenderFns } from "./Predictions.vue?vue&type=template&id=212b60b8"
import script from "./Predictions.vue?vue&type=script&lang=js"
export * from "./Predictions.vue?vue&type=script&lang=js"
import style0 from "./Predictions.vue?vue&type=style&index=0&id=212b60b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports